import classcat from "classcat";
import React from "react";
import { useTranslation } from "react-i18next";

import { TranslationContext } from "@is/constants";

import css from "./BestMatches.module.css";

export const AlternativesBestMatches = () => {
  const { t } = useTranslation(TranslationContext.ProductListing);

  return (
    <div>
      <div className={css.showMoreContainer} />

      <div className={css.alternativesContainer}>
        <span className={classcat(["text-label-2xl", css.noMoreItems])}>
          {t("No more matching items found")}
        </span>

        <h1 className={classcat(["text-headline-5xl", css.noMatchingTitle])}>
          {t("Discover other styles")}
        </h1>
      </div>
    </div>
  );
};
